import Image from 'next/legacy/image';

import { BodyLarge, BodyRegular } from '@common/body';
import { H3 } from '@common/headline';
import Button from '@common/Button/Button';
import Icon from '@common/Icons/Icon';

import NDPPGraph from '@public/img/nhs/ndpp-graph.png';
import NDPPGraphMobile from '@public/img/nhs/ndpp-graph-mobile.png';

export const LatestSuccess = (): JSX.Element => (
  <div className="bg-purple">
    <div className="container mx-auto px-4 py-16 lg:p-[75px]">
      <div className="flex flex-col lg:flex-row">
        <div className="mb-8 lg:mb-0 lg:mr-8 lg:flex-1">
          <div className="mb-4 text-purple-400">
            <BodyLarge>Independent weight loss results</BodyLarge>
          </div>
          <div className="mb-4 text-blue">
            <H3>
              Uptake and impact of the English National Health Service digital
              diabetes prevention programme: observational study. -{' '}
              <span className="text-mono-white">
                BMJ Open Diabetes Res Care.
              </span>
            </H3>
          </div>
          <div className="mb-6 text-blue lg:mb-8">
            <BodyRegular>
              NHS England has recently published a study in the BMJ looking into
              the impact of the national diabetes prevention programme on weight
              loss and HbA1c (average blood glucose). We&apos;re incredibly
              proud of our results which saw average reductions in weight of
              6.2kg and HbA1c of 2.2mmol/mol after 12 months.{' '}
            </BodyRegular>
          </div>
          <a href="https://app.hubspot.com/documents/5255756/view/307972858?accessId=ef9cff">
            <Button
              colour="NavyBlue"
              type="Primary"
              icon={<Icon name="rightArrow" />}
              fullWidth={false}
            />
          </a>
        </div>
        <div className="flex flex-1 lg:justify-end">
          <div className="my-auto hidden lg:block">
            <Image src={NDPPGraph} alt="Graph" width={447} height={352} />
          </div>
          <div className="block lg:hidden">
            <Image src={NDPPGraphMobile} alt="Graph" width={341} height={464} />
          </div>
        </div>
      </div>
    </div>
  </div>
);
